var agp = agp || {};

agp.datepicker = (function() {

	function init () {
		$('input.datepicker').Zebra_DatePicker({
			inside: false,
			show_icon: false,
			default_position: 'below',
			days: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
			months: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
			show_select_today: 'I dag',
			format: 'd-m-Y',
			lang_clear_date: 'Ryd dato',
			header_navigation: ['<span class="icon-arrow-left"></span>', '<span class="icon-arrow-right"></span>']
		});
	}

	return {
		init: init
	};

}());